(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var clamp = function (v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a === undefined ? 0 : a, v)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var root = document.documentElement, nav = $('nav'), intro = $('top');
  var LML = window.LML || {};

  /* ---------- toast ---------- */
  var toastEl = $('toast'), toastT = 0;
  function toast(msg, href, label) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    if (href) {
      var a = document.createElement('a');
      a.href = href; a.textContent = label;
      toastEl.appendChild(document.createTextNode(' '));
      toastEl.appendChild(a);
    }
    toastEl.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('show'); }, href ? 5200 : 2800);
  }

  /* ---------- store filter on the home page ---------- */
  var grid = $('grid'), chips = $('chips'), showAll = $('showAll'), filter = 'all', expanded = false;
  var cards = grid ? Array.prototype.slice.call(grid.children) : [];
  function cols() { return (getComputedStyle(grid).gridTemplateColumns || '').split(' ').filter(Boolean).length || 2; }
  function applyFilter() {
    if (!grid || !chips) return;
    var shown = 0, total = 0, limit = (filter === 'all' && !expanded) ? cols() * 2 : 999;
    cards.forEach(function (c) {
      var ok = filter === 'all' || (filter === 'free' ? c.dataset.free === '1' : (' ' + c.dataset.c + ' ').indexOf(' ' + filter + ' ') >= 0);
      if (ok) total++;
      c.hidden = !(ok && shown < limit);
      if (ok && shown < limit) shown++;
    });
    if (showAll) showAll.hidden = shown >= total;
    Array.prototype.forEach.call(chips.children, function (b) {
      var on = b.dataset.f === filter;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  window.LMLFilter = applyFilter;
  if (grid && chips) {
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.chip');
      if (!b) return;
      filter = b.dataset.f; expanded = false; applyFilter();
    });
    if (showAll) showAll.addEventListener('click', function () { expanded = true; applyFilter(); });
    applyFilter();
  }

  /* ---------- add to cart without leaving the page ---------- */
  function setCount(n) {
    var c = $('cartCount'), link = $('cart');
    if (!c) return;
    c.textContent = n;
    c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
    if (link) link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-cart]') || !window.fetch || !LML.cartAdd) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(LML.cartAdd, { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'That could not be added.'); return j; }); })
      .then(function (item) {
        return fetch(LML.cartJson, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          setCount(cart.item_count);
          toast('Added: ' + (item.product_title || 'your item') + '.', LML.cart, 'View cart');
        });
      })
      .catch(function (err) { toast(err && err.message ? err.message : 'Something went wrong. Please try again.'); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* ---------- copy buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.copy');
    if (!b) return;
    var text = b.dataset.copy, done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1600); };
    var fallback = function () {
      var s = b.previousElementSibling, r = document.createRange();
      r.selectNodeContents(s); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r);
      b.textContent = 'Selected';
    };
    try { navigator.clipboard.writeText(text).then(done, fallback); } catch (err) { fallback(); }
  });

  var flyApi = intro && $('stage') ? initFly() : null;

  function initFly() {
    /* ---------- the fly-through ---------- */
    var stage = $('stage'), sky = $('sky').firstElementChild, fly = $('fly'), door = $('door'), hero = $('hero'), hub = $('hub');
    var cue = hero.querySelector('.cue'), skip = $('skip'), doorKids = Array.prototype.slice.call(door.children);
    var F = 600, NEAR = 110, FAR = 2600, ZD = 4700, P_LAND = 0.86;
    var data = { essay: '', covers: [], reels: [] };
    try { data = JSON.parse($('flyData').textContent); } catch (e) { /* the intro still runs with labels only */ }
    var defs = [
      { k: 'tape', t: 'Learn the Law', x: -0.25, y: -0.15, z: 1250, r: -5 },
      { k: 'essay', x: 0.24, y: 0.12, z: 1550, r: 4 },
      { k: 'tape', t: 'Get Legal Support', x: 0.2, y: -0.2, z: 1950, r: 4, c: 'vest' },
      { k: 'pic', src: data.covers[0], x: -0.25, y: 0.13, z: 2250, r: -6 },
      { k: 'tape', t: 'DIY Legal Tools', x: -0.2, y: -0.19, z: 2650, r: -3, c: 'pop' },
      { k: 'pic', src: data.covers[1], x: 0.26, y: 0.1, z: 2880, r: 5 },
      { k: 'pic', src: data.covers[2], x: -0.27, y: 0.16, z: 3080, r: -4 },
      { k: 'pic', src: data.covers[3], x: 0.21, y: -0.2, z: 3280, r: 7 },
      { k: 'tape', t: 'Follow me!', x: -0.18, y: -0.16, z: 3650, r: 3, c: 'honey' },
      { k: 'reel', src: data.reels[0], x: 0.24, y: 0.05, z: 3880, r: 5 },
      { k: 'reel', src: data.reels[1], x: -0.25, y: 0.1, z: 4080, r: -6 }
    ];
    defs = defs.filter(function (d) { return d.k === 'tape' || (d.k === 'essay' ? !!data.essay : !!d.src); });
    // scraps of label tape drifting past, placed from a fixed seed so every visit looks the same
    var seed = 7;
    function rnd() { seed = (seed * 16807) % 2147483647; return seed / 2147483647; }
    var tones = ['var(--tape)', 'var(--honey)', 'var(--rim)', 'var(--paper)', 'var(--ear)'];
    for (var b = 0; b < 30; b++) {
      var bx = (rnd() - 0.5) * 1.15, by = (rnd() - 0.5) * 0.95;
      if (Math.abs(bx) < 0.1 && Math.abs(by) < 0.1) bx += bx < 0 ? -0.16 : 0.16;
      defs.push({ k: 'bit', x: bx, y: by, z: 650 + rnd() * 3900, r: rnd() * 180, w: 12 + rnd() * 34, c: tones[b % tones.length] });
    }
    var things = defs.map(function (d) {
      var el;
      if (d.k === 'tape') { el = document.createElement('span'); el.className = 'tape' + (d.c ? ' ' + d.c : ''); el.textContent = d.t; }
      else if (d.k === 'essay') { el = document.createElement('div'); el.className = 'essay'; el.innerHTML = '<small>Latest essay</small><b></b>'; el.lastChild.textContent = data.essay; }
      else if (d.k === 'bit') { el = document.createElement('i'); el.className = 'bit'; el.style.width = d.w + 'px'; el.style.height = Math.max(6, d.w * 0.34) + 'px'; el.style.background = d.c; }
      else { el = document.createElement('div'); el.className = 'pic' + (d.k === 'reel' ? ' reel' : ''); var im = new Image(); im.fetchPriority = 'low'; im.src = d.src; im.alt = ''; im.decoding = 'async'; el.appendChild(im); }
      fly.appendChild(el);
      return { d: d, el: el, on: false };
    });

    var on = false, vw = 0, vh = 0, sFill = 4, raf = 0, landed = false, lastP = -1;
    function progress() {
      var r = intro.getBoundingClientRect(), span = r.height - vh;
      return span > 0 ? clamp(-r.top / span) : 1;
    }
    function clearInline() {
      [hero, hub, door, sky, cue].forEach(function (el) { el.removeAttribute('style'); });
      hero.inert = false; hub.inert = false;
      stage.classList.remove('landed'); skip.classList.remove('show');
      things.forEach(function (t) { t.el.style.visibility = 'hidden'; t.on = false; });
    }
    function measure() {
      vw = window.innerWidth; vh = window.innerHeight;
      var tall = Math.max(1500, (window.screen && screen.height ? screen.height : 1200) * 1.5);
      var want = !reduce.matches && vh >= 540 && vh <= tall;
      if (want !== on) { on = want; root.classList.toggle('scrub', on); if (!on) clearInline(); }
      if (on) { sFill = Math.max(vw / door.offsetWidth, vh / door.offsetHeight) * 1.35; }
      lastP = -1; frame(); if (window.LMLFilter) window.LMLFilter();
    }
    function frame() {
      raf = 0;
      tone();
      if (!on) return;
      var p = progress();
      if (p === lastP) return;
      lastP = p;
      var t = Math.min(1, p / P_LAND);
      var e = 0.45 * t + 0.55 * (t < 0.5 ? 2 * t * t : 1 - 2 * (1 - t) * (1 - t));
      var cam = (ZD - F / sFill) * e;
      var kx = vw < 700 ? 0.62 : 1;
      var g = clamp((cam - 60) / 320);

      // the opening screen flies past first
      var dh = F - cam;
      if (dh > 150) {
        hero.style.visibility = 'visible';
        hero.style.transform = 'scale(' + (F / dh).toFixed(4) + ')';
        hero.style.opacity = clamp((dh - 150) / 270).toFixed(3);
        hero.inert = dh < 420;
      } else { hero.style.visibility = 'hidden'; hero.inert = true; }
      cue.style.opacity = clamp(1 - p * 14).toFixed(2);
      sky.style.transform = 'scale(' + (1 + e * 1.8).toFixed(3) + ')';

      var isLanded = p >= P_LAND;
      if (isLanded !== landed) { landed = isLanded; stage.classList.toggle('landed', landed); }
      skip.classList.toggle('show', p > 0.03 && p < P_LAND - 0.04);

      for (var i = 0; i < things.length; i++) {
        var th = things[i], d = th.d.z - cam;
        if (landed || d < NEAR || d > FAR) { if (th.on) { th.el.style.visibility = 'hidden'; th.on = false; } continue; }
        var s = F / d;
        th.el.style.visibility = 'visible'; th.on = true;
        th.el.style.opacity = (Math.min(clamp((FAR - d) / 700), clamp((d - NEAR) / 170)) * g).toFixed(3);
        th.el.style.zIndex = Math.round(9000 - d);
        th.el.style.transform = 'translate(-50%,-50%) translate3d(' + (th.d.x * vw * kx * s).toFixed(1) + 'px,' + (th.d.y * vh * s).toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ') rotate(' + th.d.r + 'deg)';
      }

      // the cream tag in the distance is the way in
      var dd = ZD - cam, ds = F / dd;
      if (landed) { door.style.visibility = 'hidden'; }
      else {
        door.style.visibility = 'visible';
        door.style.opacity = clamp((4350 - dd) / 600).toFixed(3);
        door.style.transform = 'translate(-50%,-50%) scale(' + ds.toFixed(4) + ')';
        var fade = clamp(1 - (ds - 1.25) / 0.8).toFixed(3);
        doorKids.forEach(function (k) { k.style.opacity = fade; });
      }

      var th2 = clamp((p - P_LAND) / 0.07);
      if (th2 > 0) {
        hub.style.visibility = 'visible';
        hub.style.opacity = th2.toFixed(3);
        hub.style.transform = 'translateY(' + ((1 - th2) * 26).toFixed(1) + 'px)';
        hub.inert = th2 < 0.6;
      } else { hub.style.visibility = 'hidden'; hub.inert = true; }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(frame); }
    return { measure: measure, queue: queue, isOn: function () { return on; }, progress: progress, land: P_LAND, hero: hero, hub: hub };
  }

  /* ---------- top bar tone and the current section ---------- */
  var darkZones = [document.querySelector('.watch'), $('live'), document.querySelector('.shopify-policy__title'), $('foot')].filter(Boolean);
  var sections = ['top', 'store', 'live', 'blog', 'watch', 'about', 'talk'].map($).filter(Boolean);
  var navLinks = Array.prototype.slice.call(document.querySelectorAll('.links a, .tabs a'));
  function tone() {
    if (!nav) return;
    var y = nav.offsetHeight / 2, dark = false, inIntro = false, i;
    if (flyApi) {
      var ir = intro.getBoundingClientRect();
      inIntro = ir.top <= y && ir.bottom > y;
      if (inIntro) dark = flyApi.isOn() ? flyApi.progress() < flyApi.land - 0.02 : flyApi.hero.getBoundingClientRect().bottom > y;
    }
    if (!inIntro) {
      for (i = 0; i < darkZones.length; i++) { var r = darkZones[i].getBoundingClientRect(); if (r.top <= y && r.bottom > y) { dark = true; break; } }
    }
    nav.classList.toggle('on-dark', dark);
    nav.classList.toggle('clear', dark && inIntro);
    if (flyApi) {
      var cur = 'top', mark = (window.innerHeight || 800) * 0.45;
      for (i = 0; i < sections.length; i++) { if (sections[i].getBoundingClientRect().top <= mark) cur = sections[i].id; }
      navLinks.forEach(function (a) { a.setAttribute('aria-current', a.dataset.nav === cur ? 'true' : 'false'); });
    }
  }

  /* ---------- moving around ---------- */
  var playing = 0;
  function stopPlay() { if (playing) { cancelAnimationFrame(playing); playing = 0; } }
  function glideTo(y, ms) {
    stopPlay();
    var y0 = window.scrollY, t0 = performance.now();
    if (reduce.matches || ms <= 0) { window.scrollTo(0, y); return; }
    (function step(now) {
      var k = clamp((now - t0) / ms), ek = k < 0.5 ? 2 * k * k : 1 - 2 * (1 - k) * (1 - k);
      window.scrollTo(0, y0 + (y - y0) * ek);
      playing = k < 1 ? requestAnimationFrame(step) : 0;
    })(t0);
  }
  ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, function (e) { if (ev === 'mousedown' && e.target.closest && e.target.closest('#stepIn')) return; stopPlay(); }, { passive: true }); });
  function landingY() { var r = intro.getBoundingClientRect(); return window.scrollY + r.top + (r.height - window.innerHeight) * 0.985; }
  var stepIn = $('stepIn'), skipBtn = $('skip');
  if (stepIn && flyApi) stepIn.addEventListener('click', function () {
    if (flyApi.isOn()) glideTo(landingY(), 4600);
    else glideTo(window.scrollY + flyApi.hub.getBoundingClientRect().top - nav.offsetHeight, 600);
  });
  if (skipBtn && flyApi) skipBtn.addEventListener('click', function () { glideTo(landingY(), 500); });
  // links to a spot on the page you are already on glide there instead of jumping
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank' || a.classList.contains('skip-link')) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    var id = url.hash.slice(1), el = id ? $(id) : (flyApi ? intro : null);
    if (!el) return;
    e.preventDefault();
    var y = el === intro ? 0 : window.scrollY + el.getBoundingClientRect().top - (nav ? nav.offsetHeight : 0) + 1;
    glideTo(y, clamp(Math.abs(y - window.scrollY) / (window.innerHeight || 800) * 260, 350, 900));
    cleanAddress();
  });

  // Keep the address plain. A section marker or a sent-form result left in it is what the browser
  // remembers, and the next visit to that address opens at that section instead of the top.
  function cleanAddress() {
    if (!history.replaceState) return;
    var p, drop = [], id = location.hash.slice(1), q = location.search;
    try { p = new URLSearchParams(q); } catch (e) { return; }
    p.forEach(function (v, k) { if (k === 'contact_posted' || (k === 'form_type' && v === 'contact') || k.indexOf('contact[') === 0) drop.push(k); });
    if (!drop.length && !(id && (id === 'talkForm' || sections.some(function (el) { return el.id === id; })))) return;
    if (drop.length) { drop.forEach(function (k) { p.delete(k); }); q = p.toString(); q = q ? '?' + q : ''; }
    history.replaceState(history.state, '', location.pathname + q);
  }

  /* ---------- the talk form ---------- */
  // note that a message was just sent from this tab: its result is shown once, never again from a remembered address
  var talkForm = $('talkForm');
  if (talkForm) talkForm.addEventListener('submit', function () { try { sessionStorage.setItem('lmlSent', '1'); } catch (e) { /* storage is off: the result still shows */ } });
  // Form-filling browser add-ons fill a form the moment a page opens, and filling a field pulls the page down to it.
  // So the form's fields stay switched off until the visitor is almost at the form.
  if (talkForm && 'IntersectionObserver' in window) {
    var talkFields = Array.prototype.filter.call(talkForm.elements, function (f) { return f.type !== 'hidden' && !f.disabled; });
    talkFields.forEach(function (f) { f.disabled = true; });
    var wakeIo = new IntersectionObserver(function (es) {
      if (!es.some(function (en) { return en.isIntersecting; })) return;
      talkFields.forEach(function (f) { f.disabled = false; });
      wakeIo.disconnect();
    }, { rootMargin: '200px 0px' });
    wakeIo.observe(talkForm);
  }

  /* ---------- watch: each video plays in its own frame, one at a time ---------- */
  (function () {
    var band = document.querySelector('.watch');
    if (!band) return;
    var tiles = Array.prototype.map.call(band.querySelectorAll('.vid'), function (fig) {
      return { fig: fig, video: fig.querySelector('video'), btn: fig.querySelector('.vid-play') };
    }).filter(function (t) { return t.video && t.btn; });
    var row = band.querySelector('.reels'), showing = null, swipedAt = 0;
    var rotArm = function () {}; // becomes the rotation timer when there is more than one wide video

    function full(t) { return document.fullscreenElement === t.video || t.video.webkitDisplayingFullscreen; }
    function reveal(t) {
      if (!row || !row.contains(t.fig)) return;
      var r = t.fig.parentNode.getBoundingClientRect(), b = row.getBoundingClientRect();
      var d = r.left < b.left + 8 ? r.left - b.left - 8 : (r.right > b.right - 8 ? r.right - b.right + 8 : 0);
      if (d) row.scrollBy({ left: d, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    function stop(t) {
      t.video.pause();
      try { t.video.currentTime = 0; } catch (e) { /* nothing was loaded yet */ }
      t.video.controls = false;
      t.fig.classList.remove('is-on');
      t.btn.hidden = false;
      if (showing === t) showing = null;
      rotArm();
    }
    function start(t) {
      tiles.forEach(function (o) { if (o !== t && (o === showing || !o.video.paused)) stop(o); });
      // on a slow or data-saving connection, Shopify's stream (which adjusts to the connection) starts sooner than the full-size file
      var net = navigator.connection, stream = t.video.dataset.stream;
      if (net && (net.saveData || /2g|3g/.test(net.effectiveType || '')) && stream && !t.video.getAttribute('src') && t.video.canPlayType('application/vnd.apple.mpegurl')) t.video.src = stream;
      showing = t;
      t.fig.classList.add('is-on');
      t.btn.hidden = true;
      t.video.controls = true;
      var p = t.video.play();
      if (p && p.catch) p.catch(function () { /* the player's own play button is still there */ });
      try { t.video.focus({ preventScroll: true }); } catch (e) { /* focus is a nicety */ }
      reveal(t);
      rotArm();
    }
    tiles.forEach(function (t) {
      // without this script the plain player with its cover still works; with it, the cover is the play button
      t.video.controls = false;
      t.btn.hidden = false;
      t.btn.addEventListener('click', function () { if (performance.now() - swipedAt > 400) start(t); });
      t.video.addEventListener('play', function () { if (showing !== t) start(t); });
      t.video.addEventListener('ended', function () { if (!full(t)) stop(t); });
    });
    if ('IntersectionObserver' in window) {
      // a playing video pauses when it is swiped out of the row or the band leaves the screen
      var seen = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!showing || en.target !== showing.video || en.intersectionRatio >= 0.25 || full(showing)) return;
          showing.video.pause();
        });
      }, { threshold: [0, 0.25] });
      tiles.forEach(function (t) { seen.observe(t.video); });
    }

    // the wide frame: several wide videos take turns
    var rot = band.querySelector('.rot'), slides = rot ? Array.prototype.slice.call(rot.querySelectorAll('.rot-track > .story')) : [];
    if (slides.length > 1) {
      var bar = rot.querySelector('.rot-bar'), track = rot.querySelector('.rot-track'), hold = rot.querySelector('[data-rot="pause"]');
      var dots = Array.prototype.slice.call(rot.querySelectorAll('.rot-dot'));
      var every = (parseFloat(rot.dataset.rotate) || 0) * 1000, at = 0, timer = 0, hover = false, focused = false, inView = !('IntersectionObserver' in window);
      var off = every <= 0 || reduce.matches; // off: nothing moves by itself
      var show = function (i) {
        at = (i + slides.length) % slides.length;
        slides.forEach(function (sl, k) {
          var on = k === at;
          sl.classList.toggle('is-at', on);
          sl.inert = !on;
          if (!on) tiles.forEach(function (t) { if (t.fig === sl && (t === showing || !t.video.paused)) stop(t); });
        });
        dots.forEach(function (d, k) { d.setAttribute('aria-current', k === at ? 'true' : 'false'); });
        rotArm();
      };
      var setOff = function (v) {
        off = v;
        hold.setAttribute('aria-pressed', off ? 'true' : 'false');
        hold.setAttribute('aria-label', off ? 'Start rotation' : 'Pause rotation');
        rotArm();
      };
      rotArm = function () {
        clearTimeout(timer);
        if (off || every <= 0) return;
        timer = setTimeout(function () {
          // hold still while something plays, while the visitor is on the frame, or while nobody can see it
          if (showing || hover || focused || !inView || document.hidden) rotArm(); else show(at + 1);
        }, every);
      };
      slides.forEach(function (sl, k) {
        sl.setAttribute('role', 'group');
        sl.setAttribute('aria-roledescription', 'slide');
        sl.setAttribute('aria-label', (k + 1) + ' of ' + slides.length);
      });
      rot.addEventListener('pointerenter', function () { hover = true; });
      rot.addEventListener('pointerleave', function () { hover = false; });
      // keyboard focus holds the frame still; a mouse press on its buttons does not
      rot.addEventListener('focusin', function (e) { try { focused = e.target.matches(':focus-visible'); } catch (err) { focused = true; } });
      rot.addEventListener('focusout', function () { focused = false; });
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        if (b === hold) { setOff(!off); return; }
        var i = dots.indexOf(b);
        show(i >= 0 ? i : at + (b.dataset.rot === 'prev' ? -1 : 1));
        setOff(true);
      });
      // a sideways swipe on the cover moves to the next one; a playing video keeps its own controls
      var sx = 0, sy = 0, down = false;
      track.addEventListener('pointerdown', function (e) { down = e.pointerType !== 'mouse'; sx = e.clientX; sy = e.clientY; });
      track.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5 || slides[at].classList.contains('is-on')) return;
        swipedAt = performance.now();
        show(at + (dx < 0 ? 1 : -1));
        setOff(true);
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].intersectionRatio >= 0.4; }, { threshold: [0, 0.4] }).observe(rot);
      rot.classList.add('is-js');
      bar.hidden = false;
      if (every <= 0) hold.hidden = true;
      show(0);
      setOff(off);
    }

    // the row of tall videos: arrows for a mouse, swipe for a finger
    var rowNav = band.querySelector('.reels-nav');
    if (row && rowNav) {
      var prevB = rowNav.querySelector('[data-reels="prev"]'), nextB = rowNav.querySelector('[data-reels="next"]'), rowRaf = 0;
      var ends = function () {
        rowRaf = 0;
        var max = row.scrollWidth - row.clientWidth;
        rowNav.hidden = max < 8;
        prevB.disabled = row.scrollLeft < 8;
        nextB.disabled = row.scrollLeft > max - 8;
      };
      rowNav.addEventListener('click', function (e) {
        var b = e.target.closest('button'), first = row.querySelector('.reel-slot');
        if (!b || !first) return;
        var stepW = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 16);
        row.scrollBy({ left: (b.dataset.reels === 'prev' ? -2 : 2) * stepW, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
      row.addEventListener('scroll', function () { if (!rowRaf) rowRaf = requestAnimationFrame(ends); }, { passive: true });
      window.addEventListener('resize', ends);
      ends();
    }
  })();

  /* ---------- policy pages: a label and date in the title band, a contents list, reading progress ---------- */
  (function () {
    var box = document.querySelector('.shopify-policy__container');
    var head = box && box.querySelector('.shopify-policy__title'), body = box && box.querySelector('.shopify-policy__body');
    var text = body && (body.querySelector('.rte') || body);
    if (!head || !text) return;
    var make = function (tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html) n.innerHTML = html; return n; };
    var h1 = head.querySelector('h1'), heads = Array.prototype.slice.call(text.querySelectorAll('h2'));
    var homeLink = document.querySelector('#nav a[href]');
    root.classList.add('is-policy');

    // title band: a label, where you are, and the date the policy last changed
    var kicker = make('p', 'policy-kicker', '<span class="tape honey"></span><span class="policy-crumbs"><a></a> / <span aria-current="page"></span></span>');
    kicker.querySelector('.tape').textContent = box.dataset.label || 'Policy';
    kicker.querySelector('a').href = homeLink ? homeLink.href : '/';
    kicker.querySelector('a').textContent = 'Home';
    kicker.querySelector('[aria-current]').textContent = h1 ? h1.textContent.trim() : document.title;
    head.insertBefore(kicker, head.firstChild);
    var first = text.querySelector('p');
    if (first && /^\s*last updated/i.test(first.textContent)) {
      var when = make('span');
      when.textContent = first.textContent.trim();
      first.textContent = '';
      first.appendChild(when);
      first.className = 'policy-updated';
      head.appendChild(first);
    }
    var lede = text.querySelector('p');
    if (lede) lede.classList.add('policy-lede');

    // closing card: where to go with a question
    var talk = document.querySelector('.foot a[href$="#talk"]'), choices = text.querySelector('a[href*="data-sharing-opt-out"]');
    var end = make('div', 'policy-end', '<p></p><div class="policy-end-links"><a class="btn btn-ink">Get in touch</a></div>');
    end.querySelector('p').textContent = box.dataset.question || 'Have a question about this policy?';
    end.querySelector('a').href = talk ? talk.href : '/pages/contact';
    if (box.dataset.policyUrl) {
      var policy = make('a', 'btn btn-ghost');
      policy.href = box.dataset.policyUrl;
      policy.textContent = box.dataset.policyTitle || 'Privacy policy';
      end.lastChild.appendChild(policy);
    }
    if (choices) {
      var choice = make('a', 'btn btn-ghost');
      choice.href = choices.href;
      choice.textContent = 'Your privacy choices';
      end.lastChild.appendChild(choice);
    }
    text.appendChild(end);
    var up = make('button', 'policy-top');
    up.type = 'button';
    up.textContent = 'Back to top ↑';
    up.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' }); });
    text.appendChild(up);

    if (heads.length < 3) return;
    // contents list: every heading gets an address of its own, so a section can be linked to
    var toc = make('nav', 'policy-toc'), list = make('ol'), bar = make('div', 'policy-bar', '<i></i>');
    var toggle = make('button', 'policy-toc-toggle', '<span>On this page</span><small></small><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9.5 6 6 6-6"/></svg>');
    toggle.type = 'button';
    toggle.querySelector('small').textContent = heads.length + ' sections';
    toc.setAttribute('aria-label', 'On this page');
    heads.forEach(function (h, i) {
      var id = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
      while (document.getElementById(id) && document.getElementById(id) !== h) id += '-' + (i + 1);
      h.id = id;
      var li = make('li'), a = make('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.appendChild(toggle);
    toc.appendChild(bar);
    toc.appendChild(list);
    var grid = make('div', 'policy-grid');
    text.parentNode.insertBefore(grid, text);
    grid.appendChild(toc);
    grid.appendChild(text);
    var narrow = window.matchMedia('(max-width: 900px)');
    var setOpen = function (open) {
      toc.dataset.open = open ? 'true' : 'false';
      toggle.setAttribute('aria-expanded', open || !narrow.matches ? 'true' : 'false');
    };
    setOpen(false);
    toggle.addEventListener('click', function () { if (narrow.matches) setOpen(toc.dataset.open !== 'true'); });
    list.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!a) return;
      if (history.replaceState) history.replaceState(history.state, '', a.getAttribute('href'));
      setOpen(false);
    });

    // which section is being read, and how far through the policy the reader is
    var links = Array.prototype.slice.call(list.querySelectorAll('a')), fill = bar.firstChild, raf = 0, last = -2;
    var mark = function () {
      raf = 0;
      var line = (nav ? nav.offsetHeight : 0) + 48, cur = -1, r = text.getBoundingClientRect();
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= line) cur = i; });
      fill.style.transform = 'scaleX(' + clamp((line - r.top) / Math.max(1, r.height - (window.innerHeight - line))).toFixed(3) + ')';
      if (cur === last) return;
      last = cur;
      links.forEach(function (a, i) { if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      // keep the current line in view inside the list when the list itself has to scroll
      if (cur >= 0 && !narrow.matches && toc.scrollHeight > toc.clientHeight) {
        var lr = links[cur].getBoundingClientRect(), tr = toc.getBoundingClientRect();
        if (lr.top < tr.top + 8) toc.scrollTop += lr.top - tr.top - 8;
        else if (lr.bottom > tr.bottom - 8) toc.scrollTop += lr.bottom - tr.bottom + 8;
      }
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(mark); }, { passive: true });
    window.addEventListener('resize', function () { setOpen(toc.dataset.open === 'true'); mark(); });
    mark();
  })();

  /* ---------- the live show: countdown, "happening now", postponed, and the deck of clips ---------- */
  (function () {
    var cfg = null;
    try { cfg = JSON.parse($('liveData').textContent); } catch (e) { return; }
    var body = document.body, all = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var ZONES = { 'America/New_York': ['Eastern', 'ET'], 'America/Chicago': ['Central', 'CT'], 'America/Denver': ['Mountain', 'MT'], 'America/Los_Angeles': ['Pacific', 'PT'] };
    var zone = ZONES[cfg.zone] ? cfg.zone : 'America/Chicago', zoneName = ZONES[zone][0], zoneShort = ZONES[zone][1];
    var clock = String(cfg.time || '19:30').split(':'), HOUR = +clock[0] || 0, MINUTE = +clock[1] || 0, LONG = (cfg.minutes || 60) * 6e4;
    var liveUrl = cfg.profile ? cfg.profile.replace(/\/$/, '') + '/live' : '';

    /* when is the next live, wherever the visitor is */
    var zoneClock = new Intl.DateTimeFormat('en-US', { timeZone: zone, hourCycle: 'h23', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' });
    function inZone(date) {
      var o = {};
      zoneClock.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
      return { wd: DAYS.indexOf(o.weekday), y: +o.year, mo: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute };
    }
    function fromZone(y, mo, d, h, mi) {
      var want = Date.UTC(y, mo - 1, d, h, mi), guess = want;
      for (var k = 0; k < 3; k++) { var p = inZone(new Date(guess)); guess -= Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi) - want; }
      return new Date(guess);
    }
    // every live from now on, soonest first; one in progress counts as the first
    function shows(now, howMany) {
      var out = [];
      for (var i = 0; out.length < howMany && i < 7 * (howMany + 2); i++) {
        var p = inZone(new Date(now.getTime() + i * 864e5));
        if (p.wd !== cfg.day) continue;
        var start = fromZone(p.y, p.mo, p.d, HOUR, MINUTE), end = new Date(start.getTime() + LONG);
        if (end > now && !(out.length && +out[out.length - 1].start === +start)) out.push({ start: start, end: end });
      }
      return out;
    }

    /* flip-style digits */
    var UNITS = [['days', 'd'], ['hrs', 'h'], ['min', 'm'], ['sec', 's']];
    function setFlap(el, ch) {
      if (el.textContent === ch) return;
      if (reduce.matches || !el.dataset.set) { el.textContent = ch; el.dataset.set = '1'; return; }
      el.classList.remove('is-in'); el.classList.add('is-out');
      setTimeout(function () { el.textContent = ch; el.classList.remove('is-out'); el.classList.add('is-in'); }, 160);
    }
    var clocks = all('[data-flaps]');
    clocks.forEach(function (host) {
      host.innerHTML = UNITS.map(function (u, i) {
        return (i ? '<span class="flap-sep"><i></i><i></i></span>' : '') + '<span class="flap-unit"><span class="flap-pair"><b class="flap" data-k="' + u[1] + '1">0</b><b class="flap" data-k="' + u[1] + '0">0</b></span><em>' + u[0] + '</em></span>';
      }).join('');
    });
    function setFlaps(left) {
      var s = Math.max(0, Math.floor(left / 1000));
      var v = { d: Math.min(99, Math.floor(s / 86400)), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      clocks.forEach(function (host) {
        all('.flap', host).forEach(function (el) { var k = el.dataset.k, two = ('0' + v[k[0]]).slice(-2); setFlap(el, two[k[1] === '1' ? 0 : 1]); });
      });
    }

    /* the topic: each live talks through the essay that dropped the week before, so it is the newest one
       that was already out a day ahead of the show (the one that drops as the show starts is next week's) */
    var essays = [];
    try { essays = JSON.parse($('liveEssays').textContent); } catch (e) { /* no essay list on this page */ }
    function topicFor(show) {
      for (var i = 0; i < essays.length; i++) if (essays[i].at * 1000 <= show.start.getTime() - 864e5) return essays[i];
      return null;
    }

    /* wording that follows the clock */
    var fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: zone, weekday: 'long', month: 'long', day: 'numeric' });
    var fmtZoneTime = new Intl.DateTimeFormat('en-US', { timeZone: zone, hour: 'numeric', minute: '2-digit' });
    var fmtLocalTime = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', weekday: 'short' });
    var slot = DAY_NAMES[cfg.day] + 's · ' + fmtZoneTime.format(fromZone(2026, 1, 5, HOUR, MINUTE)) + ' ' + zoneShort;
    var state = '', lastMinute = -1, lastTopic = '';
    all('[data-live-link]').forEach(function (a) { a.dataset.home = a.getAttribute('href'); });
    all('[data-live-primary]').forEach(function (a) { a.hidden = false; });
    function words(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
    function sameClock(d) { var a = inZone(d); return a.h === d.getHours() && a.mi === d.getMinutes() && a.d === d.getDate(); }
    function each(sel, fn) { all(sel).forEach(fn); }

    function tick() {
      var now = new Date(), skip = Math.max(0, cfg.skip || 0), list = shows(now, skip + 1), show = list[skip];
      if (!show) return null;
      var left = show.start - now, s = skip > 0 ? 'postponed' : (left <= 0 ? 'live' : (left <= 15 * 6e4 ? 'soon' : 'count'));
      var today = inZone(now).d === inZone(show.start).d && left < 864e5, dayWord = today ? 'Tonight' : 'This ' + DAY_NAMES[cfg.day];
      var note = cfg.note || ('This week’s live is postponed. We’re back ' + fmtDay.format(show.start) + ' at ' + fmtZoneTime.format(show.start) + ' ' + zoneName + '.');
      var topic = topicFor(show), title = topic ? topic.title : '';
      if (s !== state || title !== lastTopic) {
        state = s; lastTopic = title; body.dataset.live = s;
        each('[data-live-chip]', function (el) { el.textContent = s === 'live' ? 'Live stream happening now' : (s === 'soon' ? 'Starting soon on TikTok' : (s === 'postponed' ? 'Postponed this week' : slot)); });
        each('[data-live-sub]', function (el) {
          el.textContent = s === 'postponed' ? note : (s === 'live' ? 'Live stream happening now' + (title ? ': “' + title + '”' : '. Come on in.') : (s === 'soon' ? 'Almost time' + (title ? '. Tonight: “' + title + '”' : '. Grab a seat.') : (title ? dayWord + ': “' + title + '”' : 'Live on TikTok every week. Catch a past show while you wait.')));
        });
        each('[data-live-eyebrow]', function (el) { el.lastChild.textContent = s === 'live' ? 'Live stream' : (s === 'soon' ? 'Starting soon' : (s === 'postponed' ? 'Postponed this week · back in' : 'Next live in')); });
        each('[data-live-link]', function (a) { if (s === 'live' && liveUrl) { a.href = liveUrl; a.target = '_blank'; a.rel = 'noopener'; } else { a.setAttribute('href', a.dataset.home); a.removeAttribute('target'); } });
        each('[data-live-nav]', function (el) { el.textContent = s === 'live' ? 'Live now' : 'Live soon'; });
        each('[data-live-primary]', function (a) { a.lastChild.textContent = s === 'live' ? 'Join on TikTok' : 'Add to calendar'; });
        each('[data-live-note]', function (el) { el.hidden = s !== 'postponed'; el.innerHTML = '<b>Postponed</b>'; el.appendChild(document.createTextNode(note)); });
        each('[data-live-topic-card]', function (a) { a.hidden = !topic || s === 'postponed'; if (topic) a.href = topic.url; });
        each('[data-live-topic]', function (el) { if (topic) el.textContent = title; });
        each('[data-live-topic-k]', function (el) { el.textContent = s === 'live' || today ? 'Tonight’s topic' : 'This ' + DAY_NAMES[cfg.day] + '’s topic'; });
        each('[data-live-topic-s]', function (el) { el.textContent = s === 'live' ? 'Read along while the show is on.' : 'Read the essay, then talk it through live.'; });
      }
      setFlaps(left);
      var minute = Math.floor(now / 6e4);
      if (minute !== lastMinute) {
        lastMinute = minute;
        var secs = Math.max(0, Math.floor(left / 1000)), d = Math.floor(secs / 86400), h = Math.floor(secs / 3600) % 24, m = Math.floor(secs / 60) % 60;
        each('[data-live-sr]', function (el) { el.textContent = s === 'live' ? cfg.name + ': live stream happening now on TikTok.' : (s === 'postponed' ? note + ' ' : '') + 'Next ' + cfg.name + ' live in ' + words(d, 'day') + ', ' + words(h, 'hour') + ' and ' + words(m, 'minute') + '.'; });
        var when = fmtZoneTime.format(show.start) + ' ' + zoneName + (sameClock(show.start) ? '' : ' · ' + fmtLocalTime.format(show.start) + ' your time');
        each('[data-live-when]', function (el) { el.innerHTML = '<b></b>'; el.firstChild.textContent = fmtDay.format(show.start); el.appendChild(document.createTextNode(when)); });
      }
      return show;
    }
    (function loop() { tick(); setTimeout(loop, 1000 - (Date.now() % 1000) + 5); })();

    /* "Add to calendar": one calendar file for the next live */
    function stamp(d) { return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-live-primary]');
      if (!a) return;
      if (state === 'live' && liveUrl) { a.href = liveUrl; a.target = '_blank'; a.rel = 'noopener'; return; }
      var show = tick();
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//LabelMeLegal//Live//EN', 'BEGIN:VEVENT', 'UID:live-' + stamp(show.start) + '@labelmelegal.com', 'DTSTAMP:' + stamp(new Date()), 'DTSTART:' + stamp(show.start), 'DTEND:' + stamp(show.end), 'SUMMARY:' + cfg.name + ', live on TikTok', 'DESCRIPTION:' + cfg.name + ' goes live on TikTok: ' + liveUrl, 'URL:' + liveUrl, 'BEGIN:VALARM', 'TRIGGER:-PT15M', 'ACTION:DISPLAY', 'DESCRIPTION:' + cfg.name + ' starts in 15 minutes', 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      a.href = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
      a.download = 'real-talk-live.ics';
      a.removeAttribute('target');
    }, true);

    /* the deck of clips: a slow rotating cascade of phones */
    var deck = document.querySelector('[data-deck]');
    if (!deck) return;
    var stage = deck.querySelector('.deck-stage'), phones = all('.phone', deck), dots = all('.rot-dot', deck), hold = deck.querySelector('[data-deck-hold]'), essayLine = deck.querySelector('.deck-essay');
    var at = 0, playing = null, turn = 0, hover = false, focused = false, inView = !('IntersectionObserver' in window), off = reduce.matches, place;
    var arm = function () {
      clearTimeout(turn);
      if (off || phones.length < 2) return;
      turn = setTimeout(function () { if (playing || hover || focused || !inView || document.hidden) arm(); else place(at + 1); }, 5500);
    };
    var setOff = function (v) {
      off = v;
      if (hold) { hold.setAttribute('aria-pressed', off ? 'true' : 'false'); hold.setAttribute('aria-label', off ? 'Start rotation' : 'Pause rotation'); }
      arm();
    };
    var stop = function (p) {
      p.querySelector('video').pause(); p.classList.remove('is-on');
      p.querySelector('.phone-play').setAttribute('aria-label', 'Play: ' + p.dataset.title);
      if (playing === p) playing = null;
      arm();
    };
    var play = function (p) {
      phones.forEach(function (o) { if (o !== p && (playing === o || !o.querySelector('video').paused)) stop(o); });
      var v = p.querySelector('video'), pr;
      v.muted = false;
      pr = v.play();
      if (pr && pr.catch) pr.catch(function () { /* the visitor can press play again */ });
      p.classList.add('is-on'); playing = p;
      p.querySelector('.phone-play').setAttribute('aria-label', 'Pause: ' + p.dataset.title);
    };
    place = function (i) {
      at = (i + phones.length) % phones.length;
      phones.forEach(function (p, k) {
        var pos = k - at;
        if (pos > phones.length / 2) pos -= phones.length;
        if (pos < -phones.length / 2) pos += phones.length;
        if (phones.length === 2 && pos === -1) pos = 1;
        p.dataset.pos = Math.abs(pos) <= 1 ? String(pos) : (pos < 0 ? 'left' : 'right');
        p.setAttribute('aria-hidden', pos === 0 ? 'false' : 'true');
        if (pos !== 0 && (playing === p || !p.querySelector('video').paused)) stop(p);
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === at ? 'true' : 'false'); });
      var link = deck.querySelector('[data-deck-essay]'), cur = phones[at];
      if (essayLine && link) { essayLine.hidden = !cur.dataset.essay; if (cur.dataset.essay) { link.textContent = '“' + cur.dataset.essay + '”'; link.href = cur.dataset.essayUrl; } }
      arm();
    };
    phones.forEach(function (p, k) {
      var v = p.querySelector('video'), bar = p.querySelector('.phone-bar b'), btn = p.querySelector('.phone-play');
      var press = function (e) {
        e.stopPropagation();
        if (p.dataset.pos !== '0') { place(k); setOff(true); return; }
        if (playing === p) stop(p); else play(p);
      };
      // without this script each clip is a plain player in a row; with it, the phone itself is the play button
      v.controls = false; btn.hidden = false;
      p.addEventListener('click', press);
      btn.addEventListener('click', press);
      v.addEventListener('timeupdate', function () { if (v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration).toFixed(4) + ')'; });
      v.addEventListener('ended', function () { stop(p); v.currentTime = 0; bar.style.transform = 'scaleX(0)'; });
    });
    deck.addEventListener('click', function (e) {
      var b = e.target.closest('[data-deck-go], .rot-dot, [data-deck-hold]'), i;
      if (!b) return;
      if (b === hold) { setOff(!off); return; }
      i = dots.indexOf(b);
      place(i >= 0 ? i : at + (b.dataset.deckGo === 'prev' ? -1 : 1));
      setOff(true);
    });
    var sx = 0, sy = 0, down = false;
    stage.addEventListener('pointerdown', function (e) { down = e.pointerType !== 'mouse'; sx = e.clientX; sy = e.clientY; });
    stage.addEventListener('pointerup', function (e) {
      if (!down) return;
      down = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) { place(at + (dx < 0 ? 1 : -1)); setOff(true); }
    });
    stage.addEventListener('pointerenter', function () { hover = true; });
    stage.addEventListener('pointerleave', function () { hover = false; });
    deck.addEventListener('focusin', function (e) { try { focused = e.target.matches(':focus-visible'); } catch (err) { focused = true; } });
    deck.addEventListener('focusout', function () { focused = false; });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      inView = es[0].intersectionRatio >= 0.35;
      if (es[0].intersectionRatio < 0.2 && playing) stop(playing);
    }, { threshold: [0, 0.2, 0.35] }).observe(stage);
    deck.classList.add('is-js');
    all('.deck-bar', deck).forEach(function (el) { el.hidden = false; });
    place(0);
    setOff(off);
  })();

  /* ---------- phones: covers, chips and the buy bar ---------- */
  (function () {
    var each = function (sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); };
    var io = 'IntersectionObserver' in window;

    // video covers are all far down the page: each one loads as it comes near, not at page open
    var cover = function (v) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); };
    var near = io ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { cover(e.target); near.unobserve(e.target); } });
    }, { rootMargin: '600px' }) : null;
    each('video[data-poster]', function (v) { if (near) near.observe(v); else cover(v); });

    // a row of chips that swipes sideways opens with the chosen one in view
    each('.chips', function (row) {
      var on = row.querySelector('.is-on');
      if (on && row.scrollWidth > row.clientWidth + 1) row.scrollLeft = Math.max(0, on.offsetLeft - parseFloat(getComputedStyle(row).paddingLeft));
    });

    // product page: the buy bar shows while the main button is out of view, and steps aside for the footer
    var bar = $('buybar'), form = $('buyForm'), foot = $('foot');
    if (bar && form && io) {
      var main = form.querySelector('button[type="submit"]'), away = false, atFoot = false;
      var set = function () {
        var show = away && !atFoot;
        bar.classList.toggle('is-on', show);
        bar.inert = !show;
        document.body.classList.toggle('has-buybar', show);
      };
      new IntersectionObserver(function (es) { away = !es[0].isIntersecting; set(); }, { rootMargin: '-56px 0px -62px 0px' }).observe(main);
      if (foot) new IntersectionObserver(function (es) { atFoot = es[0].isIntersecting; set(); }, { rootMargin: '0px 0px -120px 0px' }).observe(foot);
      // the two buttons are one button: both go quiet while the item is being added
      new MutationObserver(function () { bar.querySelector('button').disabled = main.disabled; }).observe(main, { attributes: true, attributeFilter: ['disabled'] });
    }
  })();

  /* ---------- a glint on each section's label as it arrives ---------- */
  if ('IntersectionObserver' in window && !reduce.matches) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('sheen'); io.unobserve(en.target); } });
    }, { threshold: 0.9 });
    Array.prototype.forEach.call(document.querySelectorAll('.band-head .tape, .talk-copy > .tape, .about-copy > .tape'), function (el) { io.observe(el); });
  }

  var toneRaf = 0;
  function onScroll() {
    if (flyApi) flyApi.queue();
    else if (!toneRaf) toneRaf = requestAnimationFrame(function () { toneRaf = 0; tone(); });
  }
  function onResize() { if (flyApi) flyApi.measure(); else { applyFilter(); tone(); } }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onResize);
  if (reduce.addEventListener) reduce.addEventListener('change', onResize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
  // arriving with #watch, #about or #talk: line it up under the top bar, then put the address back to the plain page
  function arrive() {
    var id = location.hash.slice(1), el = id ? $(id) : null, sec = $('talk'), gap = 0, msg;
    if (el && id === 'talkForm') {
      // a sent form comes back here: show its outcome, and the heading too where the form sits beside it
      msg = el.querySelector('.form-msg:not([hidden])');
      if (sec && el.getBoundingClientRect().top - sec.getBoundingClientRect().top < window.innerHeight * 0.35) el = sec;
      else { el = msg || el; gap = 16; }
    }
    if (el && nav) window.scrollTo(0, window.scrollY + el.getBoundingClientRect().top - nav.offsetHeight - gap + 1);
    if (msg) { try { msg.focus({ preventScroll: true }); } catch (e) { /* the message is still on screen */ } }
    cleanAddress();
  }
  window.addEventListener('load', function () {
    onResize();
    var lost = $('talkLost');
    if (lost && /[?&]form_type=contact(&|$)/.test(location.search)) lost.hidden = false;
    try { sessionStorage.removeItem('lmlSent'); } catch (e) { /* nothing to clear */ }
    // after this event, not during it: Safari keeps pulling the page back to the address's own marker until loading has finished
    setTimeout(arrive, 0);
  });
  window.addEventListener('hashchange', arrive);
  onResize();
})();
